export default class Accordeon{
    constructor(element){
        this.element = element;
        
        this.init();
    }

    init(){
        const accordeons = document.querySelectorAll('.accordeon');
       
        
        for(let i = 0; i < accordeons.length; i++){
            const accordeon = accordeons[i];
            const title = accordeon.querySelector('.title');
            title.addEventListener("click", this.ToggleActive.bind(this));
        }
    }

    ToggleActive(event){
        event.currentTarget.closest('.accordeon').classList.toggle('active');
       
    }
}